export default {
  getComTabData: 'http://localhost:8080/api/comCol/getComTabData',
  getComponentList: 'http://localhost:8080/api/componentList/getComponentList',
  appendComponentList: 'http://localhost:8080/api/componentList/appendComponentList',
  adjustComponent: 'http://localhost:8080/api/componentList/adjustComponent',
  spliceComponentList: 'http://localhost:8080/api/componentList/spliceComponent',
  updateZindexComponentList: 'http://localhost:8080/api/componentList/updateZindexComponentList',
  updateComponentBasicStatus: 'http://localhost:8080/api/componentList/updateComponentBasicStatus',
  basePicurl: 'http://localhost:8080/componentImage/',
  userLogin: 'http://localhost:8080/api/user/login',
  userRegister: 'http://localhost:8080/api/user/register',
  validateAccount: 'http://localhost:8080/api/user/validateAccount',
  getScreenDef: 'http://localhost:8080/api/screen/getScreenDef',
  updateScreenDef: 'http://localhost:8080/api/screen/updateScreenDef',
  getScreenStretch: 'http://localhost:8080/api/screen/getScreenStretch',
  updateScreenStretch: 'http://localhost:8080/api/screen/updateScreenStretch',
  getBackgroundStyle: 'http://localhost:8080/api/screen/getBackgroundStyle',
  updateBackgroundStyle: 'http://localhost:8080/api/screen/updateBackgroundStyle',
  testJsonData: 'http://localhost:8080/testJsonData',
  getTemplateList: 'http://localhost:8080/api/template/getTemplateList',
  appendTemplate: 'http://localhost:8080/api/template/appendTemplate',
  spliceTemplate: 'http://localhost:8080/api/template/spliceTemplate',
  updateTemplate: 'http://localhost:8080/api/template/updateTemplate'
}
